import { render } from "./Publication.vue?vue&type=template&id=cc38d558&scoped=true&ts=true"
import script from "./Publication.vue?vue&type=script&lang=ts"
export * from "./Publication.vue?vue&type=script&lang=ts"

import "./Publication.vue?vue&type=style&index=0&id=cc38d558&scoped=true&lang=css"

import exportComponent from "/Users/shunta/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc38d558"]])

export default __exports__